import React, {Component} from 'react';
import {Row, Col} from 'react-flexbox-grid';
import Mansory from 'react-masonry-component';
import _ from "underscore";
import Front from "./Front";
import Line from "./Line";
import moment from "moment";
import LineMobile from "./LineMobile";

class Group extends Component {

    state = {
        front: [],
        list: []
    };

    componentDidMount() {
        moment.locale('fr', {
            months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
            monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
            monthsParseExact: true,
            weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
            weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
            weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm'
            },
            calendar: {
                sameDay: '[Aujourd’hui à] LT',
                nextDay: '[Demain à] LT',
                nextWeek: 'dddd [à] LT',
                lastDay: '[Hier à] LT',
                lastWeek: 'dddd [dernier à] LT',
                sameElse: 'L'
            },
            relativeTime: {
                future: 'dans %s',
                past: 'il y a %s',
                s: 'quelques secondes',
                m: 'une minute',
                mm: '%d minutes',
                h: 'une heure',
                hh: '%d heures',
                d: 'un jour',
                dd: '%d jours',
                M: 'un mois',
                MM: '%d mois',
                y: 'un an',
                yy: '%d ans'
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
            ordinal: function (number) {
                return number + (number === 1 ? 'er' : 'e');
            },
            meridiemParse: /PD|MD/,
            isPM: function (input) {
                return input.charAt(0) === 'M';
            },
            // In case the meridiem units are not separated around 12, then implement
            // this function (look at locale/id.js for an example).
            // meridiemHour : function (hour, meridiem) {
            //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
            // },
            meridiem: function (hours, minutes, isLower) {
                return hours < 12 ? 'PD' : 'MD';
            },
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4  // The week that contains Jan 4th is the first week of the year.
            }
        });
        moment.locale('fr');

        const sortColumn = this.props.configuration.sort;
        const frontColumn = this.props.configuration.front;

        let front = [];
        let list = [];

        this.props.entries.forEach(data => {
            if (data.fields[frontColumn]) {
                front.push(data);
            }
            list.push(data);
        });

        front.sort((a, b) => {
            if (a.fields[sortColumn] > b.fields[sortColumn]) {
                return 1;
            }
            if (a.fields[sortColumn] < b.fields[sortColumn]) {
                return -1;
            }
            return 0;
        });

        list.sort((a, b) => {
            if (a.fields[sortColumn] > b.fields[sortColumn]) {
                return 1;
            }
            if (a.fields[sortColumn] < b.fields[sortColumn]) {
                return -1;
            }
            return 0;
        });

        this.setState({
            front: front,
            list: list
        })
    }


    render() {
        let table = (
            <table className="List-Table">
                {this.state.list.map((entry) => {
                    return <Line entry={entry} configuration={this.props.configuration}/>
                })}
            </table>
        );

        let tableMobile = (
            <div className="List-Mobile">
                {this.state.list.map((entry) => {
                    return <LineMobile entry={entry} configuration={this.props.configuration}/>
                })}
            </div>
        );

        if (this.props.configuration.group == "Format") {
            let currentDate = null;
            let render = {};
            _.each(this.state.list, (entry) => {
                const dateStart = moment(entry.fields['Date et heure début']);

                if (currentDate === null || dateStart.format("DD/MM") !== currentDate) {
                    currentDate = dateStart.format("DD/MM");
                    render[currentDate] = {date: dateStart.format("dddd DD/MM"), entries: []}
                }
                render[currentDate].entries.push(entry);
            })

            table = [];

            _.each(render, config => {
                table.push((
                    <div>
                        <h3>{config.date}</h3>
                        <div className="List-Mobile">
                            {config.entries.map((entry) => {
                                return <Line entry={entry} configuration={this.props.configuration}/>
                            })}
                        </div>
                    </div>
                ));
            })

            tableMobile = [];

            _.each(render, config => {
                tableMobile.push((
                    <div>
                        <h3>{config.date}</h3>
                        <div className="List-Mobile">
                            {config.entries.map((entry) => {
                                return <LineMobile entry={entry} configuration={this.props.configuration}/>
                            })}
                        </div>
                    </div>
                ));
            })
            //table = render
        }

        let list = null;
        let listMobile = null;
        if (this.state.list.length > 0) {
            if (this.props.voting.slug == 'maintenant-enfants') {
                list = (<div className="MaintenantV2-Group-List">
                    <div className="MaintenantV2-Group-List-Header">
                        Les {this.state.list.length} principales activités familles du jour
                    </div>

                    <div className="MaintenantV2-Group-List-Content">
                        {table}
                    </div>
                </div>);

                listMobile = (<div className="MaintenantV2-Group-List-Mobile">
                    <div className="MaintenantV2-Group-List-Header">
                        Les {this.state.list.length} principales activités familles du jour
                    </div>

                    <div className="MaintenantV2-Group-List-Content">
                        {tableMobile}
                    </div>
                </div>);
            } else if (this.props.configuration.group == 'Alentour') {
                list = (<div className="MaintenantV2-Group-List">
                    <div className="MaintenantV2-Group-List-Header">
                        Les {this.state.list.length} activités aux alentours
                    </div>

                    <div className="MaintenantV2-Group-List-Content">
                        {table}
                    </div>
                </div>);

                listMobile = (<div className="MaintenantV2-Group-List-Mobile">
                    <div className="MaintenantV2-Group-List-Header">
                        Les {this.state.list.length} activités aux alentours
                    </div>

                    <div className="MaintenantV2-Group-List-Content">
                        {tableMobile}
                    </div>
                </div>);
            } else {
                list = (<div className="MaintenantV2-Group-List">
                    <div className="MaintenantV2-Group-List-Header">
                        Les {this.state.list.length} activités du jour
                    </div>

                    <div className="MaintenantV2-Group-List-Content">
                        {table}
                    </div>
                </div>);

                listMobile = (<div className="MaintenantV2-Group-List-Mobile">
                    <div className="MaintenantV2-Group-List-Header">
                        Les {this.state.list.length} activités du jour
                    </div>

                    <div className="MaintenantV2-Group-List-Content">
                        {tableMobile}
                    </div>
                </div>);
            }

        }

        return (
            <div className="MaintenantV2-Group">
                <div className="MaintenantV2-Group-Front">
                    {this.state.front.map((entry) => {
                        return <Front entry={entry} configuration={this.props.configuration}/>
                    })}
                </div>
                {list}
                {listMobile}
            </div>
        );
    }
}

export default Group;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCardsV2/Group.js